"use client";

import { Row, Col, Button, Form } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import { useMemo, useState, useEffect } from "react";

import ProfileInformation from "../../mycomp/MyProfile/ProfileInformation";
import TotalProjects from "../../mycomp/MyProfile/TotalProjects";
import TotalOrders from "../../mycomp/MyProfile/TotalOrders";
import TotalRevenue from "../../mycomp/MyProfile/TotalRevenue";
import AllProjects from "../../mycomp/Tables/BasicTable/AllProjects";
import Channels from "../../mycomp/Dashboard/Marketing/Channels";

import { fetchMemberAppUsage } from "../../api/api";

const DetailedReport = () => {
  const { userId } = useParams();
  const { state } = useLocation();
  const employee = state?.employee || {};
  const initialReports = state?.reports || [];

  const [reports, setReports] = useState(initialReports);
  const [appUsage, setAppUsage] = useState([]);
  const [range, setRange] = useState("daily"); // daily / weekly / monthly

  // Initialize startDate and endDate from reports or last 7 days
 const reportDates = initialReports
  .map(r => r?.date ? new Date(r.date) : null)
  .filter(d => d && !isNaN(d.getTime()));
  const today = new Date();
  // const minDate = reportDates.length
  //   ? new Date(Math.min(...reportDates)).toISOString().split("T")[0]
  //   : new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
  // const maxDate = reportDates.length
  //   ? new Date(Math.max(...reportDates)).toISOString().split("T")[0]
  //   : today.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 🔹 Load app usage whenever userId, startDate, endDate, or range changes
  useEffect(() => {
    const loadAppUsage = async () => {
      if (!startDate || !endDate) return;

      try {
        const data = await fetchMemberAppUsage(userId, range, startDate, endDate);
        setAppUsage(data);
      } catch (err) {
        console.error("Failed to load member app usage:", err);
      }
    };

    loadAppUsage();
  }, [userId, startDate, endDate, range]);

  // Filtered reports (for total projects/orders/revenue)
  const filteredReports = useMemo(() => {
    if (!startDate && !endDate) return reports;

    return reports.filter((r) => {
      const reportDate = new Date(r.date);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start && reportDate < start) return false;
      if (end && reportDate > end) return false;

      return true;
    });
  }, [reports, startDate, endDate]);

  const clearFilter = () => {
    setStartDate();
    setEndDate();
  };

  return (
    <>
      <Row>
        <Col sm={12} lg={6}>
          <ProfileInformation employee={employee} />
        </Col>

        <Col sm={12} lg={2}>
          <TotalProjects reports={filteredReports} />
        </Col>

        <Col sm={12} lg={2}>
          <TotalOrders reports={filteredReports} />
        </Col>

        <Col sm={12} lg={2}>
          <TotalRevenue reports={filteredReports} />
        </Col>
      </Row>

      {/* Date Filter */}
      <Row className="mb-3 align-items-end">
        <Col sm={12} md={3}>
          <Form.Label>From Date</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </Col>

        <Col sm={12} md={3}>
          <Form.Label>To Date</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Col>

        <Col sm={12} md={3} className="mt-3 mt-md-0">
          <Button
            variant="outline-secondary"
            onClick={clearFilter}
            disabled={!startDate && !endDate}
          >
            Clear Filter
          </Button>
        </Col>
      </Row>

      <Row>
        <Col sm={12} lg={8}>
          <AllProjects reports={filteredReports} />
        </Col>
        <Col sm={12} lg={4}>
          <Channels
            data={appUsage}
            onRangeChange={(newRange) => setRange(newRange)} // range filter works
          />
        </Col>
      </Row>
    </>
  );
};

export default DetailedReport;